import React from 'react'

const Balloon = () => (
    <svg viewBox="0 0 217 212" xmlns="http://www.w3.org/2000/svg">
        <path d="M209.35003,203.696632 C210.410139,207.34476 206.958844,210.716547 203.217565,209.676216 L179.785841,203.183433 C169.008865,200.194802 157.666179,201.263 147.179188,205.122444 C117.893098,215.911239 83.7794738,214.527226 53.4689296,197.259581 C14.4255639,175.008563 -6.66964315,130.058347 1.88966282,86.7731268 C15.6520571,17.1823815 91.5948023,-18.9110832 155.099101,10.04868 C193.13465,27.3976008 216.411875,65.992041 216.989467,106.929549 C217.224782,123.686317 213.502518,138.24167 207.310629,150.992696 C202.045741,161.820968 200.702779,174.051829 204.066127,185.572108 L209.35003,203.696632 Z" />
    </svg>
)
export default Balloon
